<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconDoubleChevronUp_24"
>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.203 6.274 6.528 10.95a.934.934 0 1 0 1.322 1.322l4.014-4.014 4.014 4.014A.934.934 0 1 0 17.2 10.95l-4.675-4.675a.934.934 0 0 0-1.322 0Zm-.156 5.454L6.37 16.403a.934.934 0 1 0 1.323 1.322l4.014-4.014 4.014 4.014a.934.934 0 1 0 1.322-1.322l-4.675-4.675a.934.934 0 0 0-1.322 0Z"
        fill="currentColor"
    />
</svg>
